import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-24 md:py-32 bg-white border-t border-black/5" data-id="element-95">
      <div className="container mx-auto px-6 md:px-12" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-97">
          {/* Left Column */}
          <div className="lg:col-span-5" data-id="element-98">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} data-id="element-99">
              <p className="text-xs font-semibold tracking-[0.3em] text-gold uppercase mb-6" data-id="element-100">
                {t('about.eyebrow')}
              </p>
              <h2 className="text-3xl md:text-4xl font-serif italic text-[#0A0A0A] leading-tight" data-id="element-101">
                {t('about.tagline')}
              </h2>
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-7" data-id="element-102">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="prose prose-neutral prose-p:text-black/70 prose-p:leading-relaxed prose-p:font-light max-w-none" data-id="element-103">
              <p className="text-lg mb-6" data-id="element-104">{t('about.paragraph1')}</p>
              <p className="mb-6" data-id="element-105">{t('about.paragraph2')}</p>
              <p data-id="element-106">{t('about.paragraph3')}</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}